var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'dark-mode': _vm.$store.state.darkMode },attrs:{"id":"app"}},[_c('TopBar'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('FloatingSubscriptionWidget'),_c('MobileMiniProgramPrompt'),_c('SubscriptionFollowDialog'),_c('GlobalCoinDialogs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }